import { mutateApi } from "src/utils/api/ApiMethods"
import { getCurrentMarinaSlug } from "src/utils/url/parsing/marina"

export const updatePublicProfileFuel = ({ data }) => {
  const marinaSlug = getCurrentMarinaSlug()
  return mutateApi({
    url: `/manage/${marinaSlug}/settings/public_profile/fuel`,
    method: "PUT",
    data,
  })
}
